/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-customer',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '客户等级',
            value: 'customerLevelList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            span: 5
        },
        {
            name: '行业大类',
            value: 'industryCategoryList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '行业类型',
            value: 'industryTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '行业类型名称' },
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' }
            ],
            tableConfig: [
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' },
                { 'prop': 'industryTypeName', 'value': '行业类型名称', 'displayName': 'industryTypeName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            method: 'post',
            cbParams: ['industryTypeCode', 'industryTypeName']
        },
        {
            name: '内外渠',
            value: 'customerChannelList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'LMDM_CUSTOMER_CHANNEL',
            span: 5
        }
    ],
    columns: [
        {
            label: '客户名称',
            prop: 'customerName',
            width: 200
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 150
        },
        {
            label: '客户简称',
            prop: 'customerShortName',
            width: 180
        },
        {
            label: '客户系',
            prop: 'customerGroupCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_CUST_RELATION_TYPE',
            width: 150
        },
        {
            label: '行业大类',
            width: 150,
            prop: 'industryCategory'
        },
        {
            label: '行业类型',
            width: 100,
            prop: 'industryTypeName'
        },
        {
            label: '客户等级',
            width: 100,
            prop: 'customerLevel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '客户类型',
            width: 180,
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_RELATION_LEVEL',
            prop: 'customerBodyType'
        },
        {
            label: '内外渠',
            width: 100,
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            prop: 'customerChannel'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
